module.exports = "/static/js/ac9e73fcc8272df53d72da9f4b4d875b.png";